import React, {useEffect, useState} from 'react';
import css from '../Profile.module.scss'
import license1 from '../../../../images/license1.png'
import license2 from '../../../../images/license2.png'
import license3 from '../../../../images/license3.png'
import License from "./License";
import plus from "../../../../images/plus.svg";
import share from '../../../../images/white_share.svg'
import {RemoveScrollBar} from "react-remove-scroll-bar";
import SendLicenses from "../../../common/modals/SendLicenses";
import AddLicense from "../../../common/modals/AddLicense";
import DeleteLicense from "../../../common/modals/DeleteLicense";
import {connect} from "react-redux";
import {deleteLicense, getLicenses} from "../../../../redux/profile/profile-thunks";
import AddIytLicenses from "../../../common/modals/AddIytLicenses";
import {setIytLicenses} from "../../../../redux/profile/profile-actions";
import close from "../../../../images/close.svg";
import {useTranslation} from "react-i18next";

const Licenses = ({isDark, ...props}) => {
  const [isSendModal, setIsSendModal] = useState(false)
  const [isAddModal, setIsAddModal] = useState(false)
  const [deleteItem, setDeleteItem] = useState(null)
  const [editItem, setEditItem] = useState(null)
  const [sendItem, setSendItem] = useState(null)
  const [isIytModal, setIsIytModal] = useState(false)
  const [isAddedIytLicenses, setIsAddedIytLicenses] = useState(false)
  const {t} = useTranslation()
  useEffect(() => {
    if (props.user) {
      props.getLicenses()
    }
  }, [props.user])
  return (
    <div className={css.licenses}>
      {(isSendModal || isAddModal || deleteItem || sendItem || editItem || isIytModal) && <>
        <RemoveScrollBar/>
        <div className="overlay"/>
      </>}
      {(isSendModal || sendItem) && <SendLicenses closeModal={() => {
        setSendItem(null)
        setIsSendModal(false)
      }} sendItem={sendItem}/>}
      {(isAddModal || editItem) && <AddLicense closeModal={() => {
        setEditItem(null)
        setIsAddModal(false)
      }} editItem={editItem} openIytModal={() => setIsIytModal(true)}/>}
      {isIytModal && <AddIytLicenses closeModal={() => {
        props.setIytLicenses(null)
        setIsIytModal(false)
      }} isDark={isDark} setIsAddedIytLicenses={setIsAddedIytLicenses} />}
      {isAddedIytLicenses && <button className={'tost'}>
        {t('loadImagesForLicenses')}
        <button onClick={() => setIsAddedIytLicenses(false)} className={'tost__close'}>
          <img src={close} alt=""/>
        </button>
      </button>}
      {deleteItem && <DeleteLicense onDelete={() => props.deleteLicense(deleteItem.id)}
                                    closeModal={() => setDeleteItem(null)}
                                    licenseName={deleteItem.license_type.name}/>}
      {props.licenses?.map((lic, index) => <License isDark={isDark} onDelete={() => setDeleteItem(lic)}
                                                    license={lic} key={index}
                                                    setEditItem={setEditItem}
                                                    setSendItem={setSendItem}/>)}
      {props.isMoreLicenses && <div className="showMore__wrapper">
        <button onClick={() => props.getLicenses(props.licenses.length)} className="showMore">{t('showMore')}</button>
      </div>}
      <button onClick={() => {
        if(props.user?.is_active) {
          setIsAddModal(true)
        } else {
          props.openConfirmEmail()
        }
      }} className={`empty__plus addButton`}>
        <img src={plus} alt=""/>
      </button>
      <button onClick={() => {
        if(props.user?.is_active) {
          setIsSendModal(true)
        } else {
          props.openConfirmEmail()
        }
      }} className={`shareButton`}>
        <img src={share} alt=""/>
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  licenses: state.profileReducer.licenses,
  user: state.userReducer.user,
  isMoreLicenses: state.profileReducer.isMoreLicenses
})

export default connect(mapStateToProps, {getLicenses, deleteLicense, setIytLicenses})(React.memo(Licenses))
